/**
 * 서비스에서 넘어온 사람이 보는 콘솔 결제 화면의 틀 (#244)
 * 대시보드 메뉴 없이 가운데 카드 하나. 로그인 연동 화면(OidcAuthorizePage)과 같은 모양이다.
 */
import React from 'react';

export const GatewayCard: React.FC<{ title: string; children: React.ReactNode }> = ({ title, children }) => (
  <div className="flex min-h-screen items-center justify-center bg-gray-50 px-4">
    <div className="w-full max-w-md rounded-lg bg-white p-8 shadow">
      <h1 className="mb-4 text-lg font-semibold text-gray-900">{title}</h1>
      {children}
    </div>
  </div>
);

export const GatewaySpinner: React.FC<{ message: string }> = ({ message }) => (
  <div className="py-6 text-center">
    <div className="mx-auto mb-4 h-8 w-8 animate-spin rounded-full border-2 border-gray-200 border-t-indigo-600" />
    <p className="text-sm text-gray-500">{message}</p>
  </div>
);
